import React, { useState, useEffect } from 'react';
import {
  Grid,
  Card,
  Box,
} from '@mui/material';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "trainerRoutes";
import editRoutes from "trainingCompanyEditRoutes";
import Container from "@mui/material/Container";
import Logo from "assets/images/skill2.png";
import MKButton from "components/MKButton";
import { LocationOn } from '@mui/icons-material';
import MKTypography from "components/MKTypography";
import { useNavigate } from 'react-router-dom';
import MKAlert from "components/MKAlert";
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import MKAvatar from "components/MKAvatar";
import '../../../styles.css';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const LoadingOverlay = ({ loading, children }) => {
  return (
    <>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
          open={loading}
        >
          <Box
            sx={{
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "1",
              width: "100%",
              minHeight: "100vh",
              // display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {children}
          </Box>
        </Backdrop>
      )}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loading && children}
    </>
  );
};


const Page = () => {
  // const styles = {
  //   gridItem: {
  //     border: '1px double #ccc',
  //     borderRadius: '30px',
  //     padding: '16px',
  //     marginBottom: '16px',
  //     boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
  //     width: '500px',
  //     backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 1.0), backdropFilter: "saturate(200%) blur(30px)", boxShadow: ({ boxShadows: { xxl } }) => xxl,
  //   },
  //   trainingInfo: {
  //     display: 'flex',
  //     flexDirection: 'column',
  //   },
  //   trainingName: {
  //     // marginTop: '10px',
  //     marginBottom: '8px',
  //     fontSize: 'medium',
  //     color: 'rgb(60, 150, 190)',
  //   },
  //   gridContent: {
  //     padding: '8px',
  //   },
  // };
  const [trainingCompanyProfileCreate, setTrainingCompanyProfileCreate] = useState(false);
  const [recommendedSkillsDetails, setRecommendedSkillsDetails] = useState([]);
  const [skillErrorMessage, setSkillErrorMessage] = useState('');
  const [maxRecruitCount, setMaxRecruitCount] = useState(false);
  const [selectedTrainer, setSelectedTrainer] = useState([]);
  const [recruitSubmitCompleted, setRecruitSubmitCompleted] = useState(false);
  const [responseRecruitFromDB, setResponseRecruitFromDB] = useState("");
  const [avatarBackgroundColor, setAvatarBackgroundColor] = useState('#ccc');
  const [loading, setLoading] = useState(false);
  const [trainingCompanyProfileDetails, setTrainingCompanyProfileDetails] = useState([])

  useEffect(() => {
    let id = localStorage.getItem("userId");
    fetch(`${process.env.REACT_APP_API_URL}/api/training-companyprofile-filter/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setTrainingCompanyProfileDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("trainingCompanyProfileDetails", trainingCompanyProfileDetails);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "nocard";
    fetch(`${process.env.REACT_APP_API_URL}/api/company-skills-equvalent/${id}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          // setRecommendedSkillsDetails(data);
          setSkillErrorMessage(data.message);
          if (!data.message) {
            setRecommendedSkillsDetails(data);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("recommendedSkillsDetails", recommendedSkillsDetails);


  const navigate = useNavigate();

  const onMoreDetailsClick = (training) => {
    console.log("training", training.trainer_profile_id);
    navigate(`/app/recommendedtrainermoredetails/${training.trainer_profile_id}/`);
  };

  const onConnectClick = (trainerList) => {
    setLoading(true);
    setMaxRecruitCount(false);
    let id = localStorage.getItem("userId");
    console.log("trainerList", trainerList)
    setSelectedTrainer(trainerList);
    // setSelectedTrainerId(trainer.id);
    const data = {
      trainingCompanyID: id,
      trainerID: trainerList.trainer_profile_id,
      trainingCompanyRecruitStatus: "Yes",
      premiumStatus:trainingCompanyProfileDetails.premiumStatus,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/company-recruit-trainer/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          setRecruitSubmitCompleted(false);
          throw new Error("Response not Submitted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("Response from backend:", data.message);
        if (data.message === "Remainder reached maximum for the day") {
          setResponseRecruitFromDB(data.message);
          setMaxRecruitCount(true);
        } else if (data.message === "We have sent you a link to the Trainer to accept your request") {
          setResponseRecruitFromDB(data.message);
          setRecruitSubmitCompleted(true);
        } else {
          setResponseRecruitFromDB(data.message);
          setRecruitSubmitCompleted(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };
  console.log("selectedTrainer", selectedTrainer);

  const DialogProfileRecruitConnectClose = () => {
    setRecruitSubmitCompleted(false);
    window.location.href = "/app/trainingcompanydashboard";
  };

  const renderTrainerCards = (trainers) => {
    return trainers.map((trainer, index) => (
      <Grid item xs={6} key={trainer.id} >
        <div className="gridItemSeeMore">
          <div className="gridContentSeeMore">
            <div className="trainingInfo">
              <div style={{ fontWeight: 'bold', marginTop: '-5px', marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                <MKAvatar
                  src={`${process.env.REACT_APP_API_URL}${trainer.profilePictureName}/`}
                  alt="Profile Picture"
                  size="lg"
                  style={{ backgroundColor: avatarBackgroundColor, marginRight: '10px' }}
                />
                <MKTypography variant="subtitle1" className="trainingNameSeeMore" style={{ marginTop: '5px' }}>
                  <strong>{trainer.firstName}&nbsp;{trainer.lastName}</strong>
                </MKTypography>
              </div>
              <MKTypography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <strong><img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /></strong> {trainer.displaySkills}
                </span>
              </MKTypography>
              <MKTypography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <LocationOn style={{ marginRight: '5px' }} /> {trainer.currentLocationCountry} | {trainer.currentLocationState}  | {trainer.location}
                </span>
              </MKTypography>
              <MKTypography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <strong style={{ marginLeft: "5px" }}>Total Experience :&nbsp;</strong>{trainer.totalExperience} months
                </span>
              </MKTypography>
              <MKTypography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <strong style={{ marginLeft: "5px" }}>Avg per hour Commercial :&nbsp;</strong>{trainer.currency}&nbsp;{trainer.avgCommercialFor8hrs}
                </span>
              </MKTypography>
              <MKTypography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <strong style={{ marginLeft: '5px', marginBottom: '-3px' }}>Rating</strong>&nbsp;
                  <Stack spacing={1} style={{ marginLeft: '5px' }}>
                    <Rating
                      name="read-only"
                      value={trainer.trainerRating}
                      precision={0.5}
                      readOnly
                    />
                  </Stack>
                </span>
              </MKTypography>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
              <MKButton variant="gradient" color="info" size="small" onClick={() => onMoreDetailsClick(trainer)} style={{ padding: '5px 10px', alignSelf: 'flex-start' }}>Details</MKButton>
              <MKButton variant="gradient" color="info" size="small" onClick={() => onConnectClick(trainer)} style={{ padding: '5px 10px', alignSelf: 'flex-end' }}>Connect</MKButton>
            </div>
          </div>
        </div>
      </Grid>
    ));
  };


  return (
    <>
      <LoadingOverlay loading={loading}>
        <IdleTimeOutHandler />
        <DefaultNavbar
          routes={trainingCompanyProfileCreate ? routes : editRoutes}
          sticky
        />
        <Card
          sx={{
            minHeight: '101vh',
            height: 'auto',
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <Dialog
            open={recruitSubmitCompleted}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Notification !
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Your response has been sent to the trainer.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
              <MKButton key="ok-button8" onClick={() => { setRecruitSubmitCompleted(false); DialogProfileRecruitConnectClose(); }} variant="contained" color="info" size="small" autoFocus>
                OK
              </MKButton>
            </DialogActions>
          </Dialog>
          <div>
            {maxRecruitCount ? (
              <MKAlert color="error" dismissible >
                You've reached the daily recruit limit !
              </MKAlert>
            ) : (
              ""
            )}
          </div>
          <Container>
            <Grid container>
              <Grid item xs={12} style={{ marginTop: "150px" }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item xs={12} style={{ display: 'flex' }}>
                      <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                        <span style={{ color: 'black' }}>Recommended</span>{' '}
                        <span style={{ color: '#2e1114' }}>Trainers</span>
                      </MKTypography>
                    </Grid>
                  </Grid>

                  {recommendedSkillsDetails.length === 0 ? (
                    <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>Enhance your profile for personalized trainer recommendations.</span>
                  ) : (
                    ""
                  )}

                  {recommendedSkillsDetails.length === 0 ? (
                    ""
                  ) : (
                    <Grid container spacing={2}>
                      {renderTrainerCards(recommendedSkillsDetails)}
                    </Grid>
                  )}

                </div>
              </Grid>
            </Grid>
          </Container>
        </Card>
      </LoadingOverlay>
    </>
  );
};

export default Page;